import { useCallback, useEffect, useState } from "react";
import apiService from "../../../../services/api";

/**
 * Custom hook for managing games data and loading state
 * @returns {Object} Games data, loading state, and actions
 */
export const useUpcomingGames = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getGames = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await apiService.fetchGames({
        from: new Date().getTime(),
      });

      setGames(response.data);
    } catch (error) {
      setError("Failed to load games. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getGames();
  }, [getGames]);

  return {
    games,
    loading,
    error,
    refreshGames: getGames,
  };
};
